// À qui s'applique un skin : la joueuse ou le joueur (D-149 : sa fiche dans le club affiché, membre d'une équipe), et tout
// autre compte du club qui n'y entraîne pas — bureau, parents, supporters, bénévoles (D-154, D-157 : les coachs, plus tard).
// Le skin se voit dans ses casquettes à lui (la joueuse : Joueuse, Bénévole ; les autres : Parent, Bénévole), jamais dans une
// casquette de coach ou de bureau. La base décide (my_skins) ; ici, de quoi ne rien charger pour les autres.
// Léger (dans l'app dès l'ouverture) : les écrans des skins se chargent à la demande (src/ui/skins.ts).
import { modOn, type Ctx, type HatKey } from './context';

/** La fiche de joueuse du compte dans le club affiché, ou null (parent, coach, bureau, supporter…). */
export function skinPerson(c: Ctx) {
  const p = c.full.people.find(x => x.user_id === c.uid && x.club_id === c.club?.id);
  return p && c.full.memberships.some(m => m.person_id === p.id) ? p : null;
}

/** Bureau, parent, supporter ou bénévole du club affiché (D-154) : un compte du club (un rôle, le bureau, un enfant
 *  licencié) qui n'y joue pas et n'y entraîne pas d'équipe. */
export function skinFan(c: Ctx): boolean {
  const club = c.club?.id, f = c.full;
  if (!club || skinPerson(c)) return false;
  if (f.teams.some(t => t.club_id === club && f.pureCoach.has(t.id))) return false;
  return c.roles.some(r => r.club_id === club) || f.adminOf.some(a => a.id === club)
    || f.people.some(p => p.club_id === club && p.user_id !== c.uid);
}

/** Les skins concernent-ils ce compte dans ce club (le module allumé) ? */
export const skinsFor = (c: Ctx) => (!!skinPerson(c) || skinFan(c)) && modOn(c, 'skins');

/** La casquette affichée (une seule : celle-là ; aucune : null). */
const shownHat = (c: Ctx): HatKey | null => (c.hats.length > 1 ? c.hat : c.hats[0]?.key ?? null);

/** Le skin porté se voit-il dans la casquette affichée ? */
export const skinHatOn = (c: Ctx) => {
  if (!skinsFor(c)) return false;
  const h = shownHat(c);
  return skinPerson(c) ? c.hats.length < 2 || h === 'joueur' || h === 'benevole' : h === null || h === 'parent' || h === 'benevole';
};

/** « Mes skins » dans Moi › Apparence : la joueuse dans toutes ses casquettes ; les autres, dans les leurs. */
export const skinsInMoi = (c: Ctx) => (skinPerson(c) ? skinsFor(c) : skinHatOn(c));
